import { Button, TextField, Typography, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { MbBackdrop } from "../mb_components/mb_backdrop";
import { MbMessage } from "../mb_components/mb_message";
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { RemoveHash, SaveAna } from "../mb_constants";
import { MbApi_RestRoomCreate } from "../mb_api/mb_api_rest_room";

const MbAnagraficaNewRestRoom = ({structure, comeback}) => {

    const [id, setId] = useState(null);
    const [rest_roomCode, setRestRoomCode] = useState(null);
    const [rest_roomDesc, setRestRoomDesc] = useState(null);
    const [message, setMessage] = useState(null);
    const [displayBackdrop, setDisplayBackDrop] = useState(false);

    const eKeyDown = (e) => {
        SaveAna(e);
    }

    function eHashChange(){}

    useEffect(() => {
        
        window.addEventListener('keydown', eKeyDown);

        window.addEventListener('hashchange', eHashChange);

        if(structure){
            setId(structure[0]);
            setRestRoomCode(structure[1]);
            setRestRoomDesc(structure[2]);
        }

        return (() => {
            try{
                window.removeEventListener('keydown', eKeyDown);
            }catch(_){}
            try{
                window.removeEventListener('hashchange', eHashChange);
            }catch(_){}
        });

    }, []);

    return (
        <>
            <MbBackdrop display={displayBackdrop}/>
            <MbMessage open={message} message={message} close={() => {
                setMessage(null);
            }} />

            <Typography variant="h6"><ArrowBackIcon sx={{cursor: "pointer"}} onClick={() => RemoveHash()}/>&nbsp;&nbsp;{structure ? "Aggiorna" : "Nuova"} sala</Typography>

            <div style={{height: "20px"}}/>

            <Grid container spacing={2}>
                <Grid item xs={window.innerWidth >= 1000 ? 6 : 12}>
                    <TextField size="small" variant="outlined" label={"Codice - 5 caratteri"} style={{width: "100%"}} value={rest_roomCode} InputLabelProps={{ shrink: true }} onChange={(e) => {
                        setRestRoomCode(e.target.value);
                    }}/>
                </Grid>
                <Grid item xs={window.innerWidth >= 1000 ? 6 : 12}>
                    <TextField size="small" variant="outlined" label={"Descrizione - 200 caratteri"} style={{width: "100%"}} value={rest_roomDesc} InputLabelProps={{ shrink: true }} onChange={(e) => {
                        setRestRoomDesc(e.target.value);
                    }}/>
                </Grid>
            </Grid>

            <div style={{height: "20px"}}/>

            <div style={{width: "100%", textAlign: "right"}}>
                <Button variant="contained" className="save-button" onClick={async () => {

                    if(!rest_roomCode || !rest_roomDesc){
                        setMessage('Compilare codice e descrizione');
                        return;                        
                    }

                    if(rest_roomCode.length > 5 || rest_roomDesc.length > 200){
                        setMessage('Il codice ha lunghezza massima 5 e la descrizione 200');
                        return;                        
                    }

                    setDisplayBackDrop(true);
                    setTimeout(async () => {

			            const result = await MbApi_RestRoomCreate(JSON.stringify({
                            id: id,
                            code: rest_roomCode,
                            description: rest_roomDesc
                        }));

                        setDisplayBackDrop(false);
                        setMessage(result ? 'Sala creata con successo' : 'Errore durante la creazione della sala!');

                        if(result){
                            setId(null);
                            setRestRoomCode('');
                            setRestRoomDesc('');
                            comeback();
                        }

                    }, 1000);

                }} id="btn_save">SALVA</Button>
            </div>

        </>
    );

};

export {
    MbAnagraficaNewRestRoom
}